import AdminAvailabilityCheckResultTable from 'components/AdminAvailabilityCheckResultTable'
import AdminNurseDetailContext from 'pages/AdminNurseDetail/context'
import { nurseAvailabilityCheckListURL } from 'routes/urls'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const AdminNurseAvailabilityCheckResults: React.FC = () => {
  const {
    availabilityCheckResultsSearchForm,
    updateAvailabilityCheckResultsSearchForm,
  } = React.useContext(AdminNurseDetailContext)
  const navigate = useNavigate()
  
  return (
    <AdminAvailabilityCheckResultTable 
      form={availabilityCheckResultsSearchForm}
      updateForm={updateAvailabilityCheckResultsSearchForm}
      onRowClick={(params) => navigate(nurseAvailabilityCheckListURL(params.row.nurse_id))}
    />
  )
}

export default AdminNurseAvailabilityCheckResults